import { Helmet } from 'react-helmet-async';
import React from 'react';
import StakeholdersContainer from '../../../containers/projects/StakeholdersContainer.jsx';
import requireAuth from '../../../lib/requireAuth.jsx';
import withRouterParams from '../../../lib/withRouterParams.jsx';

const ShowStakeholders = ({ projectId }) => (
  <>
    <Helmet>
      <title>Stakeholder Analysis | ChangeSync</title>
    </Helmet>
    <StakeholdersContainer projectId={projectId} />
  </>
);

ShowStakeholders.getInitialProps = ({ query }) => ({
  projectId: Number(query.projectId),
});

export default requireAuth(withRouterParams(ShowStakeholders));
